import { ProjectEvents } from "../../../shared/helpers/projectEvents";
import { FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useDesignerById } from "../../hooks/api/useDesignerById";
import DesignerPage from "./designer";
import { DesignerLayout } from "./components/designerLayout";
import { CoreContainer } from "../../../core";
import { useDispatch } from "react-redux";
import { NavbarSearchActions } from "../../reducers/NavbarSearch";
import { ErrorPage } from "../error/ErrorPage";
import { useProfile } from "@brg/auth";
import {AppTester} from "../../../supporting";
import {DesignerGalllleryArt} from "./galllleryArt/designerGalllleryArt";
import { useGetFriendlyUrlParam } from "shared/hooks/useGetFriendlyUrlParam";


export interface DesignerWrapperProps extends ProjectEvents {
  whiteTheme?: boolean;
  ignoreContext?: boolean;
  contexts?: string[];
}

const DesignerWrapper: FC<DesignerWrapperProps> = (props) => {
  const id = useGetFriendlyUrlParam("id");
  const dispatch = useDispatch();
  const profile = useProfile();
  const { t, i18n: { language } } = useTranslation();
  const isGalleryArt = AppTester.isGalllleryArt();

  const [designer, isDesignerLoading, isDesignerError] = useDesignerById(id, language, id);

  const isMe = useMemo(() => (profile?.nickName === id || profile?.accountId === id || designer?.accountId === profile?.accountId), [profile, designer, id])

  const isGalleryArtProfile = useMemo(() => !isMe && isGalleryArt, [isMe, isGalleryArt])

  useEffect(() => {
    if (designer) {
      if (designer?.globalTypes?.includes('Employee')
      || designer?.globalTypes?.includes('Cooperator')
      || designer?.globalTypes?.includes('Student')
      || designer?.globalTypes?.includes('hsealumni')
      || AppTester.isHseSpace()) {
        dispatch(NavbarSearchActions.setDesignerType(true));
      } else {
        dispatch(NavbarSearchActions.setDesignerType(false));
      }
    }
    return () => {
      dispatch(NavbarSearchActions.setDesignerType(true));
    }
  },[designer])


  if (isDesignerLoading && !isGalleryArtProfile) {
    return (
      <CoreContainer
        id="ctr"
        style={{ marginTop: '40px', marginBottom: '40px' }}
      >
        <DesignerLayout isLoading canFeedback={false} designer={designer}/>
      </CoreContainer>
    )
  }

  //@ts-ignore
  if (isDesignerError || designer?.ErrorMessage?.includes?.("NotFound")) {
    return <ErrorPage 
      title={t("errorpage.user.not_found")}
      text={t("errorpage.user.not_found_text", {id})}
    />;
  }

  if (!designer) {
    return null
  }

  // if (isGalleryArtProfile) {
  //   return (
  //       <DesignerGalllleryArt {...props} designer={designer} />
  //   )
  // }

  return <DesignerPage {...props} designer={designer}/>
};

export default DesignerWrapper;
import { ProjectEvents } from "../../../shared/helpers/projectEvents";
import { FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useDesignerById } from "../../hooks/api/useDesignerById";
import DesignerPage from "./designer";
import { DesignerLayout } from "./components/designerLayout";
import { CoreContainer } from "../../../core";
import { useDispatch } from "react-redux";
import { NavbarSearchActions } from "../../reducers/NavbarSearch";
import { ErrorPage } from "../error/ErrorPage";
import { useProfile } from "@brg/auth";
import {AppTester} from "../../../supporting";
import {DesignerGalllleryArt} from "./galllleryArt/designerGalllleryArt";
import { useGetFriendlyUrlParam } from "shared/hooks/useGetFriendlyUrlParam";


export interface DesignerWrapperProps extends ProjectEvents {
  whiteTheme?: boolean;
  ignoreContext?: boolean;
  contexts?: string[];
}

const DesignerWrapper: FC<DesignerWrapperProps> = (props) => {
  const id = useGetFriendlyUrlParam("id");
  const dispatch = useDispatch();
  const profile = useProfile();
  const { t, i18n: { language } } = useTranslation();
  const isGalleryArt = AppTester.isGalllleryArt();

  const [designer, isDesignerLoading, isDesignerError] = useDesignerById(id, language, id);

  const isMe = useMemo(() => (profile?.nickName === id || profile?.accountId === id || designer?.accountId === profile?.accountId), [profile, designer, id])

  const isGalleryArtProfile = useMemo(() => !isMe && isGalleryArt, [isMe, isGalleryArt])

  useEffect(() => {
    if (designer) {
      if (designer?.globalTypes?.includes('Employee')
      || designer?.globalTypes?.includes('Cooperator')
      || designer?.globalTypes?.includes('Student')
      || designer?.globalTypes?.includes('hsealumni')
      || AppTester.isHseSpace()) {
        dispatch(NavbarSearchActions.setDesignerType(true));
      } else {
        dispatch(NavbarSearchActions.setDesignerType(false));
      }
    }
    return () => {
      dispatch(NavbarSearchActions.setDesignerType(true));
    }
  },[designer])


  if (isDesignerLoading && !isGalleryArtProfile) {
    return (
      <CoreContainer
        id="ctr"
        style={{ marginTop: '40px', marginBottom: '40px' }}
      >
        <DesignerLayout isLoading canFeedback={false} designer={designer}/>
      </CoreContainer>
    )
  }

  //@ts-ignore
  if (isDesignerError || designer?.ErrorMessage?.includes?.("NotFound")) {
    return <ErrorPage 
      title={t("errorpage.user.not_found")}
      text={t("errorpage.user.not_found_text", {id})}
    />;
  }

  if (!designer) {
    return null
  }

  // if (isGalleryArtProfile) {
  //   return (
  //       <DesignerGalllleryArt {...props} designer={designer} />
  //   )
  // }

  return <DesignerPage {...props} designer={designer}/>
};

export default DesignerWrapper;
